var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPduFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13v4.66l-3.5 3.51V23h-1v-1.83L12 17.65V13h8zm0-6h-2v4h-4V7h-2v4h-.01c-1.09-.01-1.99.89-1.99 1.98v5.52l3.5 3.5v3h5v-3l3.5-3.51V13c0-1.1-.9-2-2-2V7z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iNiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0yMCAxM1YxNy42NkwxNi41IDIxLjE3VjIzSDE1LjVWMjEuMTdMMTIgMTcuNjVWMTNIMjBaTTIwIDdIMThWMTFIMTRWN0gxMlYxMUgxMS45OUMxMC45IDEwLjk5IDEwIDExLjg5IDEwIDEyLjk4VjE4LjVMMTMuNSAyMlYyNUgxOC41VjIyTDIyIDE4LjQ5VjEzQzIyIDExLjkgMjEuMSAxMSAyMCAxMVY3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgPduFill as ReactComponent };